import React, { Component } from "react";
import {
  createChartCategories, analyticsCategories
} from "../../../utils/categories";
import { connect } from "react-redux";
import ChooseCategory from "../../../components/ChooseCategory/ChooseCategory";

class ChooseAnalyticsCategory extends Component {
  constructor(props) {
    super(props);
  }

  handleCategorySelection = category => {
    let link = '';
      for (let analyticsCategory of analyticsCategories) {
        if (analyticsCategory.name === category) {
          link = analyticsCategory.link;
        }
      }
    this.props.history.push({
      pathname: `/home/analytics/${link}/create`,
      state: {category}
    });
  };

  render() {
    let title = "Add Analytics";
    let description = "To graphically see the progress of your Key Performance Indicators (KPIs), first select one of the KPI categories below. You will be able to customize your new chart on the next page.";
    return (
      <ChooseCategory
        title={title}
        description={description}
        categories={createChartCategories}
        onCategoryChoose={this.handleCategorySelection}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    chartDetails: state.analytics.chartDetails
  };
};
export default connect(mapStateToProps)(ChooseAnalyticsCategory);
